export const PAGE_NAME = {
  SIGN_UP: 'SIGNUP',
  SIGNUP_MKT_SMS: 'SIGNUP_MKT_SMS',
  SIGNUP_MKT_EMAIL: 'SIGNUP_MKT_EMAIL',
  SETTLEMENT: 'SETTLEMENT',
  PURCHASE: 'PURCHASE',
  TRADE_BUY: 'TRADE_BUY',
  TRADE_SELL: 'TRADE_SELL',
  REFUND: 'REFUND',
  WITHDRAWAL_ACCOUNT: 'WITHDRAWAL_ACCOUNT',
  DEPOSIT_ACCOUNT: 'DEPOSIT_ACCOUNT',
  DEPOSIT: 'DEPOSIT',
  WITHDRAW: 'WITHDRAW',
  UNREGISTER: 'UNREGISTER',
} as const
